import LoginError from './LoginError';
class DistanceExceededFromLastConnection extends LoginError {
    constructor(options) {
        super('The investor distance currently exceeds from last connection', options);
    }
}
export default DistanceExceededFromLastConnection;
